// src/components/auth/PrivateRoute.tsx
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { CircularProgress, Box } from '@mui/material';

interface PrivateRouteProps {
  children: React.ReactNode;
  adminOnly?: boolean;
}

export const PrivateRoute: React.FC<PrivateRouteProps> = ({ children, adminOnly = false }) => {
  const { isAuthenticated, hasRole } = useAuth();
  const location = useLocation();
  const [isLoading, setIsLoading] = React.useState(true);

  React.useEffect(() => {
    // Short timeout to prevent flash of loading
    const timer = setTimeout(() => setIsLoading(false), 100);
    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress sx={{ color: '#C5A572' }} />
      </Box>
    );
  }

  if (!isAuthenticated) {
    // Redirect to login page but save the location they were trying to access
    return <Navigate to="/employee-login" state={{ from: location }} replace />;
  }

  if (adminOnly && !hasRole('ADMIN')) {
    // User is authenticated but not an admin
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

// import React from 'react';
// import { Navigate } from 'react-router-dom';
// import { useAuth } from '../../context/AuthContext';

// interface PrivateRouteProps {
//   children: React.ReactNode;
//   adminOnly?: boolean;
// }

// export const PrivateRoute: React.FC<PrivateRouteProps> = ({ children, adminOnly = false }) => {
//   const { isAuthenticated, isAdmin } = useAuth();

//   if (!isAuthenticated) {
//     return <Navigate to="/login" replace />;
//   }

//   if (adminOnly && !isAdmin) {
//     return <Navigate to="/dashboard" replace />;
//   }

//   return <>{children}</>;
// };